/**
 * Validate a `?redirect=` query param before navigating to it.
 * Only same-origin absolute paths are allowed — rejects external URLs
 * and protocol-relative `//host` values (open-redirect protection).
 */
export function isSafeRedirectPath(url: string | null): url is string {
  if (!url) return false;
  return url.startsWith('/') && !url.startsWith('//');
}
